export interface ServiceType {
  id: number;
  title: string;
  description: string;
  image: string;
}

export const services: ServiceType[] = [
  {
    id: 1,
    title: "Довършителни работи",
    description: "Професионални довършителни работи - шпакловане, боядисване, монтаж на настилки и облицовки с високо качество и прецизност.",
    image: "/dovrsitelni-raboti.jpg"
  },
  {
    id: 2,
    title: "Шпакловане",
    description: "Прецизно шпакловане за идеално гладки повърхности и перфектна основа за боядисване - гипсова, фина и други видове шпакловки.",
    image: "/spaklovane.jpeg"
  },
  {
    id: 3,
    title: "Боядисване",
    description: "Професионално боядисване на стени и тавани с качествени бои и прецизно изпълнение за перфектен завършек.",
    image: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 4,
    title: "Подови настилки",
    description: "Изграждане и монтаж на различни подови настилки - ламинат, паркет, плочки, винил и други.",
    image: "/podove-i-nastilki.jpg"
  },
  {
    id: 5,
    title: "Ремонт на бани",
    description: "Цялостни решения за бани и санитарни помещения, включително облицовки, настилки и санитария.",
    image: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 6,
    title: "Монтаж на гипсокартон",
    description: "Професионален монтаж на гипсокартонени системи - преградни стени, окачени тавани и декоративни елементи.",
    image: "/gipskarton.jpg"
  },
  {
    id: 7,
    title: "Фаянс и теракота",
    description: "Прецизен монтаж на фаянс, теракота и гранитогрес за бани, кухни и други помещения.",
    image: "https://images.unsplash.com/photo-1576698483491-8c43f0862543?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
  },
  {
    id: 8,
    title: "Декоративни мазилки",
    description: "Нанасяне на различни видове декоративни мазилки и покрития за уникален интериорен дизайн.",
    image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
  }
];
